import { css } from 'styled-components';

type breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const breakpoints = {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1400px',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const respondTo = (breakpoint: breakpoint, children: any, direction = 'max') =>
    direction === 'min'
        ? css`
              @media (min-width: ${breakpoints[breakpoint]}) {
                  ${children}
              }
          `
        : css`
              @media (max-width: ${breakpoints[breakpoint]}) {
                  ${children}
              }
          `;
